import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { merge } from 'lodash-es';

const resources: Resource = {
  en: {
    translation: {
      "editToken": {
        "title": "Edit Filler",
        "name": "Name",
        "email": "Email",
        "telephone": "Telephone",
        "dueDate": "Due Date",
        "submit": "Submit",
        "invalidEmail": "Invalid email address",
        "internalComments": "Internal Comments",
        "template": "Template",
        "copyLink": "Filler link",
        "copySuccess": "Link copied successfully!",
        "copyError": "Failed to copy link.",
        "emailButton": "Send Email",
        "emailSuccess": "Email sent successfully!",
        "createdAt": "Created At",
        "exportedAt": "Exported At",
        "filledAt": "Filled At",
        "emailSentAt": "Email Sent At",
        "age": "Age",
        "company": "Company",
        "occupation": "Occupation",
        "sendWelcomeEmail": "Send the welcome email after save",
        "saveError": "Error saving license",
        "resultFileUpload": "Upload Result File (PDF)",
        "uploadSuccess": "Upload successful!",
        "uploadError": "Upload failed.",
        "downloadResult": "Download Result",
        "downloadError": "Download failed.",
        "uploading": "Uploading...",
        "dragDropOrClick": "Drag 'n' drop a PDF here, or click to select file",
        "dropHere": "Drop the PDF here..."
      },
      "tokens": "Fillers",
      "tokenList": {
        "title": "Fillers",
        "name": "Name",
        "telephone": "Telephone",
        "dueDate": "Due Date",
        "searchLabel": "Type here to search...",
        "actions": "Actions",
        "export": "Export",
        "edit": "Edit",
        "createdAt": "Created At",
        "exportedAt": "Exported At",
        "filledAt": "Filled At",
        "emailSentAt": "Email Sent At",
        "status": "Status",
        "numberOfTokens": "Number of Licenses",
        "fetchError": "Error fetching licenses",
        "saveError": "Error saving license",
        "emailButton": "Send Email",
        "emailSuccess": "Email sent successfully!",
        "emailError": "Error sending email",
        "unknownError": "Unknown error",
        "confirmEmailHeader": "Confirm email sending",
        "confirmEmailSingle": "Send email to selected filler?",
        "confirmEmailMultiple": "Send email to {{count}} fillers?",
        "fragmentMissing": "Fragment 'pleasefill' not found.",
        "emailPreview": "Email Preview"
        ,
        "selectPartnerHeader": "Select partner",
        "selectPartner": "Select partner",
        "selectPartnerPlaceholder": "Select partner...",
        "noPartners": "No partners available"
      },
      "tokenStatus": {
        "created": "Created",
        "sent": "Sent",
        "filled": "Filled",
        "exported": "Exported"
      },
      "menu": {
        "home": "Home",
        "questionare": "Test Questionnaire",
        "tokens": "Fillers",
        "logout": "Logout",
        "messageTemplates": "Message Templates",
        "emailQueue": "Email Queue",
        "mailSettings": "Mail Settings"
      },
      "emailQueue": {
        "title": "Email Queue",
        "to": "To",
        "subject": "Subject",
        "statusLabel": "Status",
        "attempts": "Attempts",
        "createdAt": "Created",
        "lastAttemptAt": "Last Attempt",
        "sentAt": "Sent",
        "lastError": "Last Error",
        "actions": "Actions",
        "retry": "Retry",
        "retryAll": "Retry All Pending",
        "view": "View Content",
        "retrySuccess": "Retry successful",
        "retryError": "Retry failed",
        "retryAllSuccess": "{{count}} email(s) sent successfully",
        "retryAllError": "Retry all failed",
        "fetchError": "Error fetching email queue",
        "empty": "No emails in queue",
        "status": {
          "pending": "Pending",
          "sent": "Sent",
          "failed": "Failed"
        }
      },
      "messageTemplate": {
        "edit": "Edit Message Template"
      },
      "mailSettings": {
        "title": "Mail Settings",
        "type": "Delivery Type",
        "typePlaceholder": "Select delivery type...",
        "systemDescription": "Mail delivery is configured via environment variables / application properties.",
        "from": "From Address",
        "username": "Username",
        "host": "SMTP Host",
        "port": "SMTP Port",
        "tls": "TLS / SSL",
        "tlsOn": "TLS Enabled",
        "tlsOff": "TLS Disabled",
        "password": "Password",
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "tenantId": "Tenant ID (Azure AD)",
        "refreshToken": "Refresh Token",
        "set": "set",
        "notSet": "not set",
        "leaveBlankToKeep": "Leave blank to keep existing value",
        "save": "Save",
        "authorizeGoogle": "Authorize with Google",
        "authorizeMicrosoft": "Authorize with Microsoft",
        "saveSecretFirst": "Save Client ID and Client Secret first",
        "saveSuccess": "Settings saved",
        "saveError": "Failed to save settings",
        "loadError": "Failed to load settings",
        "authorizeError": "Failed to start authorization",
        "oauthSuccess": "{{provider}} authorization successful – refresh token saved",
        "oauthError": "{{provider}} authorization failed or was denied",
        "testEmail": "Send Test Email",
        "testEmailPlaceholder": "recipient@example.com",
        "test": "Send Test",
        "testSuccess": "Test email sent to {{to}}",
        "testError": "Failed to send test email"
      },
      "answers": {
        "yes": "True",
        "ratherYes": "Rather True",
        "ratherNo": "Rather False",
        "no": "False"
      },
      "login": {
        "title": "Login",
        "username": "Username",
        "password": "Password",
        "loginButton": "Login",
        "googleLoginButton": "Login with Google",
        "googleLoginError": "Error during Google login",
        "usernamePasswordLoginError": "Invalid username or password",
        "error": "Error",
        "forgotPassword": "Forgot password?",
        "enterEmail": "Please enter your email address",
        "invalidEmail": "Please enter a valid email address",
        "resetEmailSent": "Password reset email sent. Check your inbox.",
        "resetEmailError": "Unable to send password reset email",
        "success": "Success"
      },
      "partnerList": {
        "name": "Name",
        "email": "Email",
        "telephone": "Telephone",
        "numberOfTokens": "Number of Licenses",
        "actions": "Actions",
        "searchLabel": "Type here to search...",
      },
      "editPartner": {
        "name": "Name",
        "email": "Email",
        "telephone": "Telephone",
        "numberOfTokens": "Number of Licenses",
        "transactionMessages": "Transaction Messages",
        "message": "Message",
        "tokenId": "License ID",
        "number": "Number",
        "submit": "Submit",
        "createDateTime": "Create Date Time",
        "addTransaction": "Add Transaction",
        "confirmAddTransaction": "Confirm Transaction",
        "newTransactionMessage": "Transaction Message",
        "newTransactionNumber": "Transaction Number",
      },
      "newToken": {
        "success": "License created successfully!",
        "licenses": "Nr. licenses",
        "newToken": "New Filler"
      },
      "loading": "Loading...",
      "common": {
        "cancel": "Cancel",
        "send": "Send"
      }
    }
  },
  hu: {
    translation: {
      "editToken": {
        "title": "Kitöltő szerkesztése",
        "name": "Név",
        "email": "Email",
        "telephone": "Telefon",
        "dueDate": "Határidő",
        "submit": "Mentés",
        "invalidEmail": "Érvénytelen email cím",
        "internalComments": "Belső megjegyzések",
        "template": "Sablon",
        "copyLink": "Kitöltő link",
        "copySuccess": "A link sikeresen másolva!",
        "copyError": "A link másolása nem sikerült.",
        "emailButton": "Email küldése",
        "emailSuccess": "Email sikeresen elküldve!",
        "createdAt": "Létrehozva",
        "exportedAt": "Exportálva",
        "filledAt": "Kitöltve",
        "emailSentAt": "Email elküldve",
        "age": "Életkor",
        "company": "Cég",
        "occupation": "Pozició",
        "sendWelcomeEmail": "Üdvözlő email küldése mentés után",
        "saveError": "Hiba a licensz mentésekor",
        "resultFileUpload": "Eredményfájl feltöltése (PDF)",
        "uploadSuccess": "Sikeres feltöltés!",
        "uploadError": "A feltöltés nem sikerült.",
        "downloadResult": "Eredmény letöltése",
        "downloadError": "Letöltés sikertelen",
        "uploading": "Feltöltés...",
        "dragDropOrClick": "Húzza ide a PDF-et vagy kattintson a kiválasztáshoz",
        "dropHere": "Dobja ide a PDF-et..."
      },
      "tokens": "Kitöltők",
      "tokenList": {
        "title": "Kitöltők",
        "name": "Név",
        "telephone": "Telefon",
        "dueDate": "Határidő",
        "searchLabel": "Gyorskeresés",
        "actions": "Műveletek",
        "export": "Exportálás",
        "edit": "Szerkesztés",
        "createdAt": "Létrehozva",
        "exportedAt": "Exportálva",
        "filledAt": "Kitöltve",
        "emailSentAt": "Email elküldve",
        "status": "Állapot",
        "numberOfTokens": "Licenszek száma",
        "fetchError": "Hiba a licenszek lekérésekor",
        "saveError": "Hiba a licensz mentésekor",
        "emailButton": "Email küldése",
        "emailSuccess": "Email sikeresen elküldve!",
        "emailError": "Hiba az email küldésekor",
        "unknownError": "Ismeretlen hiba",
        "confirmEmailHeader": "Email küldés megerősítése",
        "confirmEmailSingle": "Elküldöd az emailt a kiválasztott kitöltőnek?",
        "confirmEmailMultiple": "Elküldöd az emailt {{count}} kitöltőnek?",
        "fragmentMissing": "'pleasefill' fragment nem található.",
        "emailPreview": "Email előnézet"
        ,
        "selectPartnerHeader": "Partner kiválasztása",
        "selectPartner": "Válasszon partnert",
        "selectPartnerPlaceholder": "Válasszon partnert...",
        "noPartners": "Nincs elérhető partner"
      },
      "tokenStatus": {
        "created": "Létrehozva",
        "sent": "Elküldve",
        "filled": "Kitöltve",
        "exported": "Exportálva"
      },
      "menu": {
        "home": "Kezdőlap",
        "questionare": "Kérdőív tesztelése",
        "editToken": "Kitöltő szerkesztése",
        "tokens": "Kitöltők",
        "logout": "Kijelentkezés",
        "messageTemplates": "Üzenet sablonok",
        "emailQueue": "Kimenő Emailek",
        "mailSettings": "Email Beállítások"
      },
      "emailQueue": {
        "title": "Kimenő Emailek",
        "to": "Címzett",
        "subject": "Tárgy",
        "statusLabel": "Állapot",
        "attempts": "Kísérletek",
        "createdAt": "Létrehozva",
        "lastAttemptAt": "Utolsó kísérlet",
        "sentAt": "Elküldve",
        "lastError": "Utolsó hiba",
        "actions": "Műveletek",
        "retry": "Újrapróbálás",
        "retryAll": "Összes függő újrapróbálása",
        "view": "Tartalom megtekintése",
        "retrySuccess": "Újraküldés sikeres",
        "retryError": "Újraküldés sikertelen",
        "retryAllSuccess": "{{count}} email sikeresen elküldve",
        "retryAllError": "Az összes újraküldése sikertelen",
        "fetchError": "Hiba az email sor lekérésekor",
        "empty": "Nincs email a sorban",
        "status": {
          "pending": "Várakozik",
          "sent": "Elküldve",
          "failed": "Sikertelen"
        }
      },
      "messageTemplate": {
        "edit": "Üzenet sablon szerkesztése"
      },
      "mailSettings": {
        "title": "Email Beállítások",
        "type": "Küldési mód",
        "typePlaceholder": "Válasszon küldési módot...",
        "systemDescription": "Az email küldés környezeti változókból / alkalmazás beállításokból kerül konfigurálásra.",
        "from": "Feladó cím",
        "username": "Felhasználónév",
        "host": "SMTP szerver",
        "port": "SMTP port",
        "tls": "TLS / SSL",
        "tlsOn": "TLS bekapcsolva",
        "tlsOff": "TLS kikapcsolva",
        "password": "Jelszó",
        "clientId": "Kliens azonosító (Client ID)",
        "clientSecret": "Kliens titok (Client Secret)",
        "tenantId": "Bérlő azonosító (Azure AD Tenant ID)",
        "refreshToken": "Frissítési token",
        "set": "beállítva",
        "notSet": "nincs beállítva",
        "leaveBlankToKeep": "Hagyja üresen a meglévő érték megőrzéséhez",
        "save": "Mentés",
        "authorizeGoogle": "Engedélyezés Google-lal",
        "authorizeMicrosoft": "Engedélyezés Microsoft-tal",
        "saveSecretFirst": "Előbb mentse el a Kliens azonosítót és a Kliens titkot",
        "saveSuccess": "Beállítások mentve",
        "saveError": "Mentés sikertelen",
        "loadError": "Betöltés sikertelen",
        "authorizeError": "Az engedélyezés indítása sikertelen",
        "oauthSuccess": "{{provider}} engedélyezés sikeres – frissítési token mentve",
        "oauthError": "{{provider}} engedélyezés sikertelen vagy elutasítva",
        "testEmail": "Teszt email küldése",
        "testEmailPlaceholder": "cimzett@pelda.hu",
        "test": "Teszt küldése",
        "testSuccess": "Teszt email elküldve: {{to}}",
        "testError": "Teszt email küldése sikertelen"
      },
      "answers": {
        "yes": "Igaz",
        "ratherYes": "Inkább igaz",
        "ratherNo": "Inkább hamis",
        "no": "Hamis"
      },
      "login": {
        "title": "Bejelentkezés",
        "username": "Felhasználónév",
        "password": "Jelszó",
        "loginButton": "Bejelentkezés",
        "googleLoginButton": "Bejelentkezés Google-lal",
        "googleLoginError": "Hiba a Google bejelentkezés során",
        "usernamePasswordLoginError": "Érvénytelen felhasználónév vagy jelszó",
        "error": "Hiba",
        "forgotPassword": "Elfelejtette a jelszavát?",
        "enterEmail": "Kérjük, adja meg az email címét",
        "invalidEmail": "Kérjük, adjon meg érvényes email címet",
        "resetEmailSent": "Jelszó-visszaállító e-mail elküldve. Ellenőrizze a postaládáját.",
        "resetEmailError": "Nem sikerült jelszó-visszaállító e-mailt küldeni",
        "success": "Siker"
      },
      "partnerList": {
        "name": "Név",
        "email": "Email",
        "telephone": "Telefon",
        "numberOfTokens": "Licenszek száma",
        "actions": "Műveletek",
        "searchLabel": "Írjon ide a kereséshez...",
      },
      "editPartner": {
        "name": "Név",
        "email": "Email",
        "telephone": "Telefon",
        "numberOfTokens": "Licenszek száma",
        "transactionMessages": "Tranzakciók",
        "message": "Megjegyzes",
        "tokenId": "Licensz ID",
        "number": "Szám",
        "submit": "Mentés",
        "createDateTime": "Létrehozás dátuma",
        "addTransaction": "Tranzakció hozzáadása",
        "confirmAddTransaction": "Tranzakció megerősítése",
        "newTransactionMessage": "Tranzakció üzenete",
        "newTransactionNumber": "Tranzakció száma",
      },
      "newToken": {
        "success": "A licensz sikeresen létrehozva!",
        "licenses": "Licenszek száma",
        "newToken": "Új kitöltő"
      },
      "loading": "Betöltés...",
      "common": {
        "cancel": "Mégse",
        "send": "Küldés"
      }
    }
  }
};

const resourcesPersonalGuide: Resource = {
  en: {
    translation: {
      "editToken": {
        "partnerName": "Expert Name",
        "partnerId": "Expert ID"
      },
      "tokenList": {
        "partnerName": "Expert Name",
        "confirmEmailSingle": "Send email to selected expert?",
        "confirmEmailMultiple": "Send email to {{count}} experts?"
      },
      "menu": {
        "partners": "Experts"
      },
      "partnerList": {
        "title": "Experts",
        "addPartner": "Add Expert",
        "noPartners": "No experts found",
        "fetchError": "Error fetching experts",
        "saveError": "Error saving expert"
      },
      "editPartner": {
        "title": "Edit Expert",
        "copyLink": "Expert link"
      },
      "newToken": {
        "success": "License created successfully!",
        "noTokens": "The expert has no licenses available."
      },
      "partnerPortal": "Expert",
      "common": {
        "cancel": "Cancel",
        "send": "Send"
      }
    }
  },
  hu: {
    translation: {
      "editToken": {
        "partnerName": "Szakértő neve",
        "partnerId": "Szakértő azonosító"
      },
      "tokenList": {
        "partnerName": "Szakértő",
        "confirmEmailSingle": "Elküldöd az emailt a kiválasztott szakértőnek?",
        "confirmEmailMultiple": "Elküldöd az emailt {{count}} szakértőnek?"
      },
      "menu": {
        "partners": "Szakértők"
      },
      "partnerList": {
        "title": "Szakértők",
        "addPartner": "Szakértő hozzáadása",
        "noPartners": "Nincsenek szakértők",
        "fetchError": "Hiba a szakértők lekérésekor",
        "saveError": "Hiba a szakértő mentésekor"
      },
      "editPartner": {
        "title": "Szakértő szerkesztése",
        "copyLink": "Szakértő link"
      },
      "newToken": {
        "noTokens": "A szakértőnek nincs elérhető licensze.",
      },
      "partnerPortal": "Szakértő",
      "common": {
        "cancel": "Mégse",
        "send": "Küldés"
      }
    }
  }
};

const resourcesTeamGuide: Resource = {
  en: {
    translation: {
      "editToken": {
        "partnerName": "Partner Name",
        "partnerId": "Partner ID"
      },
      "tokenList": {
        "partnerName": "Partner Name",
        "confirmEmailSingle": "Send email to selected partner?",
        "confirmEmailMultiple": "Send email to {{count}} partners?"
      },
      "menu": {
        "partners": "Partners"
      },
      "partnerList": {
        "title": "Partners",
        "addPartner": "Add Partner",
        "noPartners": "No partners found",
        "fetchError": "Error fetching partners",
        "saveError": "Error saving partner"
      },
      "editPartner": {
        "title": "Edit Partner",
        "copyLink": "Partner link"
      },
      "newToken": {
        "success": "License created successfully!",
        "noTokens": "The partner has no licenses available."
      },
      "partnerPortal": "Partner",
      "common": {
        "cancel": "Cancel",
        "send": "Send"
      }
    }
  },
  hu: {
    translation: {
      "editToken": {
        "partnerName": "Partner neve",
        "partnerId": "Partner azonosító"
      },
      "tokenList": {
        "partnerName": "Partner",
        "confirmEmailSingle": "Elküldöd az emailt a kiválasztott partnernek?",
        "confirmEmailMultiple": "Elküldöd az emailt {{count}} partnernek?"
      },
      "menu": {
        "partners": "Partnerek"
      },
      "partnerList": {
        "title": "Partnerek",
        "addPartner": "Partner hozzáadása",
        "noPartners": "Nincsenek partnerek",
        "fetchError": "Hiba a partnerek lekérésekor",
        "saveError": "Hiba a partner mentésekor"
      },
      "editPartner": {
        "title": "Partner szerkesztése",
        "copyLink": "Partner link"
      },
      "newToken": {
        "noTokens": "A partnernek nincs elérhető licensze.",
      },
      "partnerPortal": "Partner",
      "common": {
        "cancel": "Mégse",
        "send": "Küldés"
      }
    }
  }
};


// Adjust the initialization to dynamically load the mode-specific keys
const mode = process.env.REACT_APP_TEAMGUIDE === 'true' ? resourcesTeamGuide : resourcesPersonalGuide;

i18n
  .use(initReactI18next)
  .init({
    resources: merge(resources, mode),
    lng: "hu", // default language
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;